import { ModKeys } from "@intelligems/ig-types";

export type IPersonalizationStateSlice = {
  issuesCollapsed: { warning: boolean; error: boolean };
  warnings: { key: string; customMessage?: string; docLink?: string }[];
  errors: { key: string; customMessage?: string; docLink?: string }[];
  activatedModArr: ModKeys[];
};

export const initialPersonalizationStateSlice: IPersonalizationStateSlice = {
  issuesCollapsed: { warning: true, error: true },
  warnings: [],
  errors: [],
  activatedModArr: [],
};
